export const bindFunctionValue = (value, functionRef) => () => {
  functionRef(value);
};
